import {Service} from "@/services/Service";

export class DashboardService extends Service {
    constructor(axios) {
        super(axios, "/dashboard");
        // this.fields = [
        //     "username": this.$localStorageService.,
        //     "password": "",
        // ]
    }

    obtenerReporte(filtros) {
        this.onStart();
        return this.http.post(this.getUrl(['/obtenerReporte/']),
            this.obtenerFiltrosBusqueda(filtros))
            .then((response) => {
                // console.info("----", response.data);
                return JSON.parse(response.data)
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerImagen(token) {
        return this.http.get(this.getUrlQuery(['/obtenerImagen/'], [token]))
            .then((response) => response.data)
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTodasFotos(filtros) {
        this.onStart();
        return this.http.post(this.getUrl(['/obtenerTodasFotos']),
            this.obtenerFiltrosBusqueda(filtros))
            .then((response) => {
                return response.data;
            })
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerFiltrosBusqueda(filtros) {
        return {
            cliente:filtros.cliente,
            sucursal:filtros.sucursal,
            empleado:filtros.empleado,
            fcInicio: filtros.rango[0],
            fcFin: filtros.rango[1]
        }
    }
}